<template>
  <div class="container-fluid customPadding">
    <div id="navigationButtons" class="mb-2">
      <b-button
        variant="link"
        class="text text-dark"
        @click="
          $router.push({
            name: 'surveys',
          })
        "
        >Surveys</b-button
      ><b-icon icon="chevron-right" />
      <b-button class="text text-dark" variant="link" @click="redirectToView()"
        ><b-icon icon="folder"></b-icon> View All</b-button
      ><b-icon icon="chevron-right" />
      <span class="text text-primary">Submitted</span>
    </div>
    <div v-if="showSurvey">
      <component
        :is="detailsInfo"
        :info="information"
        :scopeData="scopeData"
        :survey="survey"
      ></component>
    </div>
    <div v-if="loading" class="text-center text-secondary my-2">
      <b-spinner class="align-middle secondary"></b-spinner>
      <strong>Loading ...</strong>
    </div>
    <div v-if="showSurvey">
      <b-card class="mt-5" style="border-radius: 16px">
        <div v-for="index in questions.length" :key="index">
          <label class="font-weight-bold">{{ index }}) {{ questions[index - 1] }}</label>
          <div class="pl-3">
            <b-card
              v-if="attributeTypes[index - 1] === 'classic'"
              bg-variant="light"
              class="p-2 mb-3 overflow-auto"
              style="max-height: 200px"
              v-html="answers[index - 1]"
            >
            </b-card>
            <div v-if="attributeTypes[index - 1] === 'StaticList'" class="text-center">
              <b-table
                :items="staticObjects[index - 1]"
                bordered
                fixed
                head-variant="light"
                hover
                small
              ></b-table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import PersonInfo from './Person/PersonInfo';

  export default {
    components: {
      PersonInfo,
    },
    name: 'SubmittedSurvey',
    metaInfo() {
      let metaTitle = this.$appName + 'Submitted Survey';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        staticObjects: [],
        showSurvey: false,
        detailsInfo: null,
        attributeTypes: [],
        questions: [],
        answers: [],
        emptyAnswer: '-----------',
        types: {
          TextArea: 'Saved_Value_Long__c',
          'Multi-Picklist': 'Saved_Value_Long__c',
          'Multi-Dropdown': 'Saved_Value_Long__c',
          Documents: 'Id',
          Picklist: 'Saved_Value__c',
          Textbox: 'Saved_Value__c',
          Date: 'Saved_Value__c',
          Email: 'Saved_Value__c',
          Number: 'Saved_Value__c',
          RadioButton: 'Saved_Value__c',
          TimePicker: 'Saved_Value__c',
        },
        eventId: '',
        studyId: '',
        params: null,
        loading: true,
        information: {},
        questionModel: [],
      };
    },
    computed: {
      survey() {
        return this.questionModel['surveys'];
      },
      scopeData() {
        return {
          studyId: this.studyId,
          eventId: this.eventId,
          surveyId: this.surveyId,
        };
      },
    },
    created() {
      this.surveyId = this.$route.params.surveyId ?? '';
      this.eventId = this.$route.params.eventId ?? '';
      this.studyId = this.$route.params.studyId ?? '';
      this.containerName = this.$route.params.containerName ?? '';
      this.detailsInfo = 'PersonInfo';
      this.params = `surveyId=${this.surveyId}&eventId=${this.eventId}&studyId=${this.studyId}`;

      this.getSubmittedSurvey();
    },
    methods: {
      async getSubmittedSurvey() {
        try {
          this.loading = true;
          let response = await axios.get(`/api/get-submitted-survey/${this.params}`);
          this.containerName = Object.keys(response.data['response'])[0];
          this.questionModel = response.data['response'][this.containerName];
          this.information = response.data['refreshDetails']['response'];
          this.modifySubmittedData(this.questionModel);
          this.showSurvey = true;
          this.loading = false;
        } catch (error) {
          this.handleError(error, 'Something went wrong while fetching this submitted survey.');
        }
      },
      handleError(error, message) {
        this.loading = false;
        let statusCode = error.response.status;
        if (statusCode === 401) {
          alert('Your session seems to have ended, please refresh');
        } else {
          this.$bvToast.toast(message, {
            title: `Error code: ${statusCode}`,
            autoHideDelay: 10000,
            toaster: 'b-toaster-top-center',
            appendToast: true,
            variant: `danger`,
          });
        }
        console.error(error);
      },
      modifySubmittedData(response) {
        for (let i = 0; i < response['Questions'].length; i++) {
          this.questions.push(response['Questions'][i]['Label__c']);
          this.attributeTypes.push('classic');
          if (response['Questions'][i]['Attribute_Type__c'] === 'StaticList') {
            this.attributeTypes.splice(i, 1, 'StaticList');
            this.collectStaticListAnswer(response, i);
          }
          if (
            Object.keys(response['QuestionAndAnswers']).includes(response['Questions'][i]['Id'])
          ) {
            this.answeredQuestions(response, i, response['Questions'][i]['Attribute_Type__c']);
          } else {
            this.noAnsweredQuestions(response, i);
          }
        }
      },
      collectStaticListAnswer(response, i) {
        let items = [];
        let id = response['Questions'][i]['Id'];
        let rows = response['Questions'][i]['Number_of_Rows__c'];
        let labels = [];
        let answers = [];
        response['ChildOfListQuestions'][id].forEach(element => {
          labels.push(element.Label__c);
          answers.push(
            this.convertStaticData(
              response['ListAnswers'][element['Id']],
              response['Questions'][i]['Number_of_Rows__c'],
            ),
          );
        });
        for (let index = 0; index < rows; index++) {
          let row = [];
          for (let j = 0; j < labels.length; j++) {
            row[labels[j]] = answers[j][index];
          }
          items.push(row);
        }
        this.staticObjects[i] = items;
      },
      redirectToView() {
        this.$router.push({
          name: 'view-person-surveys',
          params: { eventId: this.eventId },
        });
      },
      convertStaticData(answer, rows) {
        let rowArray = [];
        let rowData = answer !== undefined ? JSON.parse(answer[0]['Saved_Value_Long__c']) : '';
        if (rowData !== '') {
          Object.entries(rowData).forEach(([key, value]) => (rowArray[`${key}`] = `${value}`));
        } else rowArray = [];
        if (rowArray.length < rows) {
          for (let i = rowArray.length; i < rows; i++) {
            rowArray.push('-');
          }
        }
        return rowArray;
      },
      answeredQuestions(response, index, attributeType) {
        if (
          response['QuestionAndAnswers'][response['Questions'][index]['Id']][0][
            this.types[attributeType]
          ] === ''
        ) {
          this.answers.push(this.emptyAnswer);
        } else if (attributeType === 'Documents') {
          this.answers.push(
            location.protocol +
              '//' +
              location.host +
              '/document/' +
              response['QuestionAndAnswers'][response['Questions'][index]['Id']][0][
                this.types[attributeType]
              ],
          );
        } else {
          this.answers.push(
            response['QuestionAndAnswers'][response['Questions'][index]['Id']][0][
              this.types[attributeType]
            ],
          );
        }
      },
      noAnsweredQuestions(response, index) {
        if (response['Questions'][index]['Attribute_Type__c'] === 'SubSection') {
          this.answers.push(response['Questions'][index]['Help_Text__c']);
        } else {
          this.answers.push(this.emptyAnswer);
        }
      },
    },
  };
</script>
